import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class ImportEffectsCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:String|Number, min_date:string, max_date:string): Promise<any> {
    let args = { 
      company_id: company_id,
      date_from:min_date,
      date_to: max_date     
    }    
    let res = await this.dispatcher.dispatch('import.effects.data', args)
    this.frontend.importEffectsJobState = 'running';
    this.frontend.importEffectsJobId = res.job_id
  }
}